// Dependencies
import React, { useEffect, useState } from "react";

//Helpers
import { getValueLocalized } from "../helpers/getLocale";

const LinkBlock = ({
  balance,
  date,
  dateBig,
  value,
  description,
  icon,
  action,
  className,
  checkBox,
  isChecked,
  currency,
  colorValue,
  editable
}) => {
  const [checked, setChecked] = useState(isChecked);
  const tempLinkBlockClass = [className && className]
    .filter(elem => elem !== false)
    .join(" ");

  const renderText = (text) => {
    if (React.isValidElement(text)) return text;
    if (text === null || text === undefined || typeof text === "boolean") return "";
    if (typeof text === "object") {
      const textValue = text.title || text.value || text.label || text.name;
      return textValue === text ? "" : renderText(textValue);
    }

    return text.toString();
  };

    const option = (e) => {
      action()
      setChecked(!checked)      
      
      e.preventDefault()
    }

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);
  
  return (
    <div 
      className={`wrapper-link-block ${tempLinkBlockClass}`} 
      onClick={(e) => editable === false ? "" : option(e)}
    >
      {checkBox && (
        <label className="container-check">
          <input
            id="input-check"
            name="check"
            type="checkbox"
            checked={checked}
            disabled={editable === false}
            defaultChecked={checked}
          />
          <span className="checkmark"/>
        </label>
      )}

      <div className="subwrapper-link-block">
        {balance && (
          <span className={`date ${dateBig === true ? "big" : ""}`}>
            {renderText(date)}
          </span>
        )}
        <div className="wrapper-description">
            {!balance && icon}
            <span className="text">{renderText(description)}</span>
        </div>
      </div>

      {value !== 0 && value && (
        <span className={`balance ${ colorValue ? colorValue : value > 0 ? "blue" : "orange"} ${currency ? "blurry" : ""}`}>
          {currency
            ? getValueLocalized("en-US", value, "$", "currency").formated.split(".")[0]
            : renderText(value)}
        </span>
      )}
    </div>
  );
};

export default LinkBlock;
